var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.6 54.2",
    style: {
      enableBackground: "new 0 0 52.6 54.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ABABAB;}\n\t.st1{fill:#009D63;}\n\t.st2{fill:#004597;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,4.1C48.6,1.6,46.3,0,43.5,0c-5,0-10,0-15,0s-10,0-15,0c-2.8,0-5.1,1.5-6.2,4.1C6.9,5,6.7,5.9,6.7,6.9 v40.6c0,3,1.7,5.4,4.4,6.4c0.7,0.3,1.4,0.4,2.2,0.4h15.1h15.1c0.8,0,1.5-0.1,2.2-0.4c2.7-1,4.4-3.4,4.4-6.4V6.9 C50.1,5.9,50,5,49.7,4.1z M47.4,27.1c0,6.8,0,13.7,0,20.5c0,1.9-1.2,3.4-3,3.8c-0.4,0.1-0.7,0.1-1.1,0.1c-5,0-9.9,0-14.9,0 s-9.9,0-14.9,0c-0.4,0-0.8,0-1.1-0.1c-1.8-0.4-3-1.9-3-3.8c0-6.8,0-13.7,0-20.5V7c0-0.4,0-0.8,0.1-1.2c0.4-1.8,1.9-3,3.8-3 c5,0,10,0,15,0s10,0,15,0c2,0,3.5,1.2,3.8,3c0.1,0.4,0.1,0.8,0.1,1.2V27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.4,40c-2.6,0-5.3,0-7.9,0c-1.2,0-1.7-0.5-1.7-1.7c0.1-4.9,3.8-9,8.7-9.5c5-0.5,9.6,3,10.4,8 c0.1,0.5,0.1,1.1,0.1,1.6c0,1.1-0.5,1.6-1.5,1.6C33.8,40,31.1,40,28.4,40z M28.4,37.4c2,0,4,0,6.1,0c0.8,0,0.8,0,0.6-0.8 c-0.8-3.2-3.5-5.2-6.8-5.1c-3.1,0-5.7,2.2-6.5,5.3c-0.1,0.5,0,0.6,0.5,0.6C24.3,37.4,26.4,37.4,28.4,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1,20.5c0-3.5,2.9-6.3,6.4-6.3c3.5,0,6.3,2.9,6.2,6.5c0,3.4-2.9,6.2-6.3,6.2C24.9,26.8,22.1,23.9,22.1,20.5 z M28.4,16.9c-2,0-3.6,1.6-3.6,3.5c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C32,18.4,30.5,16.9,28.4,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,9.3H3.8c-0.7,0-1.3,0.6-1.3,1.3v0c0,0.7,0.6,1.3,1.3,1.3h8.6c0.7,0,1.3-0.6,1.3-1.3v0 C13.7,9.9,13.1,9.3,12.4,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,20.3H3.8c-0.7,0-1.3,0.6-1.3,1.3v0c0,0.7,0.6,1.3,1.3,1.3h8.6c0.7,0,1.3-0.6,1.3-1.3v0 C13.7,20.9,13.1,20.3,12.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,31.3H3.8c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.6,1.3,1.3,1.3h8.6c0.7,0,1.3-0.6,1.3-1.3l0,0 C13.7,31.9,13.1,31.3,12.4,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.4,42.4H3.8c-0.7,0-1.3,0.6-1.3,1.3v0c0,0.7,0.6,1.3,1.3,1.3h8.6c0.7,0,1.3-0.6,1.3-1.3v0 C13.7,43,13.1,42.4,12.4,42.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.87e3b7a88d00dd1732ecad8fbf3bfc26.svg";
export { ForwardRef as ReactComponent };